import { render, staticRenderFns } from "./LoanStat.vue?vue&type=template&id=68592b3c&scoped=true"
import script from "./LoanStat.vue?vue&type=script&lang=js"
export * from "./LoanStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68592b3c",
  null
  
)

export default component.exports